[
  {
    "teaser": { "family": "Flat Mobile", "name": "One", "accent": "orange" },
    "icons": ["mobile", "speed"]
  },
  {
    "teaser": { "family": "Flat Mobile", "name": "One", "accent": "orange" },
    "icons": ["speed", "globe", "phone"]
  },
  {
    "teaser": { "family": "Flat Mobile", "name": "Two", "accent": "orange" },
    "icons": ["speed", "globe", "phone"]
  },
  {
    "teaser": { "family": "Flat Mobile", "name": "Three", "accent": "orange" },
    "icons": ["speed", "globe", "phone"]
  },
  {
    "teaser": { "family": "Flat Mobile", "name": "Three", "accent": "orange" },
    "icons": ["mobile", "exit"]
  },
  {
    "teaser": { "family": "Flat Mobile", "name": "Three", "accent": "orange" },
    "icons": []
  }
]
